module.exports = __webpack_public_path__ + "img/tw.3bbe4ac0.png";